var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editorInitialized)?_c('div',{staticClass:"wrapper"},[_c('Editor',{attrs:{"init":_vm.init,"disabled":_vm.disabled},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }